import api from "../api/api";

export const createCooperativeMember = async (payload) => {
  const response = await api.post("/cooperative-members", payload);
  return response.data;
};

export const getAllCooperativeMembers = async () => {
  const response = await api.get("/cooperative-members");
  return response.data.data;
};

export const getCooperativeMemberById = async (id) => {
  const response = await api.get(`/cooperative-members/${id}`);
  return response.data;
};

export const updateCooperativeMember = (id, payload) => {
  return api.put(`/cooperative-members/${id}`, payload);
};

export const deleteCooperativeMember = async (id) => {
  const response = await api.delete(`/cooperative-members/${id}`);
  return response.data;
};
